import { Typography, Box, Button } from '@mui/material';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

export default function NotFound() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 10 }}>
      <Typography variant="h1" sx={{ mb: 2 }}>
        404
      </Typography>
      <Typography variant="body1" sx={{ mb: 4 }}>
        {t('common.pageNotFound')}
      </Typography>
      <Button variant="contained" color="primary" onClick={() => navigate('/projects')}>
        {t('common.backToProjects')}
      </Button>
    </Box>
  );
}
